import { AppName, type VenueEventListViewModel } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the venue page.
 */
export const useVenuePageModelData = (): VenueEventListViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.Venue) {
    throw new Error("useVenuePageModelData must be used on the venue page only");
  }
  return data;
};
